import { pruneUrlFromUnnecessaryCharacters } from '@utility/checkout-utils';

import type { GlobalApiPaymentDetails } from '../../types/payment';

import type { GetRedirectUrlsResult } from './getRedirectUrls.types';

export const getRedirectUrls = (
  flow: GlobalApiPaymentDetails['paymentInitiationFlow'] | null | undefined
): GetRedirectUrlsResult => {
  if (
    flow?.status === 'PROCESSING' &&
    'details' in flow &&
    flow.details?.reason === 'AWAITING_USER_REDIRECT'
  ) {
    return {
      directUrl:
        pruneUrlFromUnnecessaryCharacters(flow.details.redirect.directUrl) ||
        null,
      proxyUrl:
        pruneUrlFromUnnecessaryCharacters(flow.details.redirect.url) || null,
    };
  }

  return { directUrl: null, proxyUrl: null };
};

export const getRedirectUrlsFromPayment = (
  response: GlobalApiPaymentDetails | null
) => getRedirectUrls(response?.paymentInitiationFlow);
